// One sidebar route; the routine page is a child so it shares the parent's meta.
export default {
  path: '/v5/routines',
  children: [
    { path: '', name: 'V5_routines', component: () => import('./RoutinesPage.vue') },
    { path: ':slug', name: 'V5_routine', component: () => import('./RoutinePage.vue') },
    { path: ':slug/edit', name: 'V5_routine_edit', component: () => import('./RoutineEditPage.vue') },
  ],
};
